import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {BlogService} from '../services/blog.service';
import {Observable, of} from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ICmsLink } from '../classes/interfaces';

@Injectable()
export class LandingPageConfigResolver implements Resolve<any> {
  constructor(private blogService: BlogService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<LandingPageConfigResponse> {
    const config = !!route.url[0] && route.url[0].path !== 'home' ? route.url[0].path.toLowerCase() : 'canada';
    return this.blogService.getByTags(['cms-config-' + config]).pipe(
      map((res) => {
        return res[0].content.content.renderedAsJson[0];
      }),
      catchError((err) => {
        return of(null);
      }));
  }
}

export interface LandingPageConfigResponse {
  heroImageUrl: string;
  heroVideoUrl: string;
  heroCampaignImageUrl: string;
  popularCities: Array<ICmsLink>;
}
